export enum ApiSuffixType {
  NoSuffix = "NoSuffix",
  DynamicFormsScheme = "DynamicFormsScheme",
  DropdownItems = "DropdownItems",
  DropdownItemsFiltered = "DropdownItemsFiltered",
  ServerSearch = "ServerSearch",
}
